import React from 'react';
import { ArrowUpRightIcon, ClipboardListIcon } from 'lucide-react';
type FormAccessButtonProps = {
  href: string;
};
export function FormAccessButton({
  href
}: FormAccessButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col justify-between gap-6 rounded-2xl bg-ink p-5 text-white transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#1f1f1f] focus:outline-none focus-visible:ring-4 focus-visible:ring-cnt-cyan/60 active:translate-y-0 sm:p-6" data-id="element-1" data-mp="2f7upf00s4y10">
      <div className="flex items-start justify-between" data-id="element-2" data-mp="1vk54ncr9fy1a">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cnt-red" data-id="element-3" data-mp="1vika3n4y4f3f">
          <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-4" data-mp="1rkwba904u269" />
        </span>
        <ArrowUpRightIcon className="h-6 w-6 text-white/70 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-white" aria-hidden="true" data-id="element-5" data-mp="1mjfbyhxaqnrs" />
      </div>
      <div className="text-left" data-id="element-6" data-mp="35r8tpsuaelma">
        <span className="block whitespace-nowrap text-xl font-semibold tracking-tight sm:text-2xl" data-id="element-7" data-mp="35sagguko0wju">
          Remplir le formulaire
        </span>
        <span className="mt-1 block text-sm text-white/65" data-id="element-8" data-mp="2rxrciep2pkzf">
          Accessible dès maintenant
        </span>
      </div>
    </a>;
}